<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
            <b-row>
              <b-col lg="12" sm="12">
                <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
              <b-form  @submit.prevent="handleSubmit(register)" @reset.prevent="reset" enctype="multipart/form-data">
                <ValidationProvider name="Organization name" vid="org_name" rules="required">
                  <b-form-group
                    class="row"
                    label-cols-sm="3"
                    label-for="org_name"
                    slot-scope="{ valid, errors }"
                  >
                    <template v-slot:label>
                      {{ $t('org_pro.org_name')}} <span class="text-danger">*</span>
                    </template>
                  <b-form-input
                      id="org_name"
                      v-model="org_profile.org_name"
                      :state="errors[0] ? false : (valid ? true : null)"
                      ></b-form-input>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider name="Organization name (bn)">
                  <b-form-group
                    class="row"
                    label-cols-sm="3"
                    label-for="org_name_bn"
                    slot-scope="{ valid, errors }"
                  >
                   <template v-slot:label>
                      {{ $t('org_pro.org_name_bn')}}
                    </template>
                  <b-form-input
                      id="org_name_bn"
                      v-model="org_profile.org_name_bn"
                      :state="errors[0] ? false : (valid ? true : null)"
                      ></b-form-input>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider name="Abbreviation Name">
                  <b-form-group
                    class="row"
                    label-cols-sm="3"
                    label-for="abbreviation"
                    slot-scope="{ valid, errors }"
                  >
                   <template v-slot:label>
                      {{ $t('org_pro.abbreviation_name')}}
                    </template>
                  <b-form-input
                      id="abbreviation"
                      v-model="org_profile.abbreviation"
                      :state="errors[0] ? false : (valid ? true : null)"
                      ></b-form-input>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider name="Abbreviation Name (bn)">
                  <b-form-group
                    class="row"
                    label-cols-sm="3"
                    label-for="abbreviation_bn"
                    slot-scope="{ valid, errors }"
                  >
                   <template v-slot:label>
                      {{ $t('org_pro.abbreviation_name_bn')}}
                    </template>
                  <b-form-input
                      id="abbreviation_bn"
                      v-model="org_profile.abbreviation_bn"
                      :state="errors[0] ? false : (valid ? true : null)"
                      ></b-form-input>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider name="Establishment year">
                  <b-form-group
                    class="row"
                    label-cols-sm="3"
                    :label="$t('org_pro.establishment_year')"
                    label-for="establishment_year"
                    slot-scope="{ valid, errors }"
                  >
                  <b-form-input
                      id="establishment_year"
                      v-model="org_profile.establishment_year"
                      :state="errors[0] ? false : (valid ? true : null)"
                      ></b-form-input>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider name="About Organizaion" rules="">
                  <b-form-group
                    class="row"
                    label-cols-sm="3"
                    :label="$t('org_pro.about_org')"
                    label-for="about_org"
                    slot-scope="{ valid, errors }"
                  >
                  <vue-editor
                  id="about_org"
                  useCustomImageHandler
                  v-model="org_profile.about_org"
                  :state="errors[0] ? false : (valid ? true : null)"
                  ></vue-editor>
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider name="About Organizaion (bn)" rules="">
                  <b-form-group
                    class="row"
                    label-cols-sm="3"
                    :label="$t('org_pro.about_org_bn')"
                    label-for="about_org_bn"
                    slot-scope="{ valid, errors }"
                  >
                  <vue-editor
                  id="about_org_bn"
                  useCustomImageHandler
                  v-model="org_profile.about_org_bn"
                  :state="errors[0] ? false : (valid ? true : null)"
                  ></vue-editor>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider name="Mission" rules="">
                  <b-form-group
                    class="row"
                    label-cols-sm="3"
                    :label="$t('org_pro.mission')"
                    label-for="mission"
                    slot-scope="{ valid, errors }"
                  >
                 <vue-editor
                  id="mission"
                  useCustomImageHandler
                  v-model="org_profile.mission"
                  :state="errors[0] ? false : (valid ? true : null)"
                  ></vue-editor>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider name="Mission (bn)" rules="">
                  <b-form-group
                    class="row"
                    label-cols-sm="3"
                    :label="$t('org_pro.mission_bn')"
                    label-for="mission_bn"
                    slot-scope="{ valid, errors }"
                  >
                  <vue-editor
                  id="mission_bn"
                  useCustomImageHandler
                  v-model="org_profile.mission_bn"
                  :state="errors[0] ? false : (valid ? true : null)"
                  ></vue-editor>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider name="Vision" rules="">
                  <b-form-group
                    class="row"
                    label-cols-sm="3"
                    :label="$t('org_pro.vision')"
                    label-for="vision"
                    slot-scope="{ valid, errors }"
                  >
                <vue-editor
                  id="vision"
                  useCustomImageHandler
                  v-model="org_profile.vision"
                  :state="errors[0] ? false : (valid ? true : null)"
                  ></vue-editor>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider name="Vision (bn)" rules="">
                  <b-form-group
                    class="row"
                    label-cols-sm="3"
                    :label="$t('org_pro.vision_bn')"
                    label-for="vision_bn"
                    slot-scope="{ valid, errors }"
                  >
                  <vue-editor
                  id="vision_bn"
                  useCustomImageHandler
                  v-model="org_profile.vision_bn"
                  :state="errors[0] ? false : (valid ? true : null)"
                  ></vue-editor>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider name="Logo">
                  <b-form-group
                    class="row"
                    label-cols-sm="3"
                    :label="$t('org_pro.logo')"
                    label-for="upload_logo"
                    slot-scope="{ valid, errors }"
                  >
                  <b-form-file id="upload_logo"
                  v-on:change="onFileChange"
                  v-model="org_profile.upload_logo"
                   class="mt-3" plain
                   :state="errors[0] ? false : (valid ? true : null)"
                   ></b-form-file>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider name="Hierarchy" rules="required">
                  <b-form-group
                    class="row"
                    label-cols-sm="3"
                    :label="$t('org_pro.hierarchy')"
                    label-for="hierarchy"
                    slot-scope="{ valid, errors }"
                  >
                  <b-form-input
                      id="hierarchy"
                      v-model="org_profile.hierarchy"
                      :state="errors[0] ? false : (valid ? true : null)"
                      ></b-form-input>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </b-form-group>
                </ValidationProvider>
                <div class="row">
                  <div class="col-sm-3"></div>
                  <div class="col text-right">
                    <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                    &nbsp;
                    <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-4')">{{ $t('globalTrans.cancel') }}</b-button>
                  </div>
                </div>
              </b-form>
            </ValidationObserver>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '../../../../../config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { commonServiceBaseUrl } from '../../../../../config/api_config'
import { orgProfileStore, orgProfileUpdate } from '../../api/routes'
import { VueEditor } from 'vue2-editor'

export default {
  props: ['id'],
  components: {
    ValidationObserver,
    ValidationProvider,
    VueEditor
  },
  created () {
    if (this.id) {
      const tmp = this.getOrgrofileData()
      // Object.freeze(tmp)
      this.org_profile = tmp
    }
  },
  mounted () {
    core.index()
  },
  data () {
    return {
      saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
      org_profile: {
        id: null,
        org_name: '',
        org_name_bn: '',
        abbreviation: '',
        abbreviation_bn: '',
        establishment_year: '',
        about_org: '',
        about_org_bn: '',
        mission: '',
        mission_bn: '',
        vision: '',
        vision_bn: '',
        logo: '',
        hierarchy: ''
      },
      upload_logo: ''
    }
  },
  computed: {},
  methods: {
    getOrgrofileData () {
      const tmpData = this.$store.state.list.find(item => item.id === this.id)
      return JSON.parse(JSON.stringify(tmpData))
    },
    onFileChange (e) {
      this.upload_logo = e.target.files[0]
    },
    async register () {
      this.$store.dispatch('mutateCommonProperties', { loading: true })
      let result = null
      const loadinState = { loading: false, listReload: true }
      const config = {
        headers: { 'content-type': 'multipart/form-data' }
      }

      var formData = new FormData()
      Object.keys(this.org_profile).map(key => {
        if (key === 'logo') {
          formData.append(key, this.upload_logo)
        } else {
          formData.append(key, this.org_profile[key])
        }
      })

      if (this.org_profile.id) {
        formData.append('_method', 'PUT')
        formData.append('updated_by', 1)
        result = await RestApi.postData(commonServiceBaseUrl, `${orgProfileUpdate}/${this.id}`, formData)
      } else {
        formData.append('created_by', 1)
        result = await RestApi.postData(commonServiceBaseUrl, orgProfileStore, formData, config)
      }
      this.$store.dispatch('mutateCommonProperties', loadinState)
        if (result.success) {
            this.$store.dispatch('mutateCommonProperties', { hasDropdownLoaded: false })
            this.$toast.success({
            title: this.$t('globalTrans.success'),
            message: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
            color: '#D6E09B'
            })

            this.$bvModal.hide('modal-4')
        } else {
            this.$refs.form.setErrors(result.errors)
        }
    }
  }
}
</script>

<style>
  #about_org , #about_org_bn , #mission , #mission_bn, #vision , #vision_bn {
    height: 100px
  }
</style>
